import { AddressBook } from './user/AddressBook.js';
import { Shipments } from './shipments/Shipments.js';
import { ServiceRepository } from '../../domains/service/ServiceRepository.js';
import { Stats } from './stats/Stats.js';
import { Invoices } from './invoices/Invoices.js';
import { getPaymentMethods } from '../../models/Payment/PaymentMethod.js';
import { PaymentAvailableMethod } from '../../models/Payment/PaymentAvailableMethod.js';
import { Client } from '../../models/Client/Client.js';
import { Parcel } from '../../models/Parcel/Parcel.js';
import { User } from '../../models/User/User.js';

class Pro {
  /** @deprecated import ServiceRepository instead */

  constructor(apiClient) {
    this.apiClient = apiClient;
    this.addresses = new AddressBook(apiClient);
    this.shipments = new Shipments(apiClient);
    this.services = new ServiceRepository(apiClient);
    this.stats = new Stats(apiClient);
    this.invoices = new Invoices(apiClient);
  }
  init() {
    return this.apiClient.get('pro/init').then(_ref => {
      let {
        data
      } = _ref;
      return {
        availablePaymentMethods: data.available_payment_methods.map(PaymentAvailableMethod.createFromResponse),
        client: Client.createFromResponse(data.client),
        parcels: data.parcels.map(Parcel.createFromResponse),
        paymentMethods: getPaymentMethods(data.payment_methods),
        user: User.createFromResponse(data.user)
      };
    });
  }
}

export { Pro };
//# sourceMappingURL=Pro.js.map
